(function () {
  var header = document.getElementById('arrebol-header');
  if (!header) return;

  var stickyEnabled = header.getAttribute('data-sticky') === 'true';

  function onScroll() {
    if (window.scrollY > 40) {
      header.classList.add('is-scrolled');
    } else {
      header.classList.remove('is-scrolled');
    }
  }
  if (stickyEnabled) {
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  } else {
    header.style.position = 'absolute';
  }

  var burger = document.getElementById('arrebol-header-burger');
  var mobile = document.getElementById('arrebol-header-mobile');
  if (burger && mobile) {
    burger.addEventListener('click', function () {
      var isOpen = !mobile.hasAttribute('hidden');
      if (isOpen) {
        mobile.setAttribute('hidden', '');
        burger.setAttribute('aria-expanded', 'false');
      } else {
        mobile.removeAttribute('hidden');
        burger.setAttribute('aria-expanded', 'true');
      }
    });
  }
})();
